export default class campaignFilterHistory {
    constructor(filterHistory) {
        return {
            saveCampaignContactFilter(
                levelOfInterests,
                selectedLevelOfInterest
            ) {
                filterHistory.saveFilter(
                    {
                        investorSubtypes: [],
                        levelOfInterests: levelOfInterests.map((item) => ({
                            value: item.filterKey,
                            name: item.name,
                            color: item.color,
                            checked: item.apiKey === selectedLevelOfInterest,
                            items: item.items
                                ? item.items.map((subitem) => {
                                      return {
                                          value: subitem.filterKey,
                                          name: subitem.name,
                                          checked:
                                              subitem.apiKey ===
                                              selectedLevelOfInterest,
                                          color: subitem.color,
                                      };
                                  })
                                : null,
                        })),
                    },
                    'campaign-contact'
                );
            },
        };
    }
}

campaignFilterHistory.inject = ['filterHistory'];



/** WEBPACK FOOTER **
 ** ./src/app/services/campaignFilterHistory.js
 **/